import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const EcomComponentWrapper = ({
  titleClassName = 'h4',
  title,
  additionalTitle,
  tooltip,
  className,
  ...props
}) => (
  <div
    className={classNames(
      'ecom-component space-y-3 p-4 bg-white border',
      className
    )}
  >
    {(title || tooltip || additionalTitle) && (
      <div className="d-flex align-items-center">
        {title != null && (
          <div
            className={classNames(
              'ecom-component__title d-inline-block',
              titleClassName
            )}
          >
            {title}
          </div>
        )}
        {tooltip && (
          <OverlayTrigger
            placement="bottom"
            trigger="click"
            rootClose
            overlay={<Tooltip>{tooltip}</Tooltip>}
          >
            <i
              role="button"
              className="fas fa-question-circle icon__after-text text-primary"
            />
          </OverlayTrigger>
        )}
        {additionalTitle && <div className="ms-auto">{additionalTitle}</div>}
      </div>
    )}
    {props.children}
  </div>
);

EcomComponentWrapper.propTypes = {
  titleClassName: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  additionalTitle: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default EcomComponentWrapper;
